import React from 'react'
import NxRange from '../NxRange'
import { hourStringToMinutes, minutesToTimeString } from '../../../utils/helpers'

export default class Index extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: [hourStringToMinutes(props.values[0]), hourStringToMinutes(props.values[1])],
    }

    this.handleRangeChange = this.handleRangeChange.bind(this)
    this.applyRangeChange = this.applyRangeChange.bind(this)
  }

  handleRangeChange(value) {
    this.setState({ value })
  }

  applyRangeChange() {
    const { value } = this.state
    const newVal = {}

    if (typeof this.props.fields !== 'string') {
      for (let i = 0; i < this.props.fields.length; i++) newVal[this.props.fields[i]] = minutesToTimeString(value[i])
    } else {
      newVal[this.props.fields] = [minutesToTimeString(value[0]), minutesToTimeString(value[1])]
    }

    this.props.onChange(newVal)
  }

  render() {
    return (
      <div className='hours-range mb-3'>
        <small className='text-muted'>{`${minutesToTimeString(this.state.value[0])} - ${minutesToTimeString(this.state.value[1])}`}</small>
        <NxRange
          step={1}
          min={0}
          max={1439}
          tooltip={false}
          onChange={this.handleRangeChange}
          onAfterChange={this.applyRangeChange}
          value={this.state.value}
        />
      </div>
    )
  }
}
